export const dialogAdvisorConfig = {
  ask_input_max_length: 1000,
  agent_limit: 3,
  min_posts_num: 3,
  max_posts_num: 10,
} as const;
